import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i2 from 'app-services-library';

class StepStatusUpdatePayloadService {
    constructor(httpClient, appServicesLibraryService) {
        this.httpClient = httpClient;
        this.appServicesLibraryService = appServicesLibraryService;
    }
    // step status update payload construction
    payloadConstruction(stepDetails, status, responseNote = '', isBeneficiaryNotifyCustom = null) {
        return {
            benchMarkActionCode: '',
            endDate: '',
            isAttorneyNotify: stepDetails['isAttorneyNotify'],
            isBeneficiaryNotify: isBeneficiaryNotifyCustom === true || isBeneficiaryNotifyCustom === false ? (isBeneficiaryNotifyCustom ? 1 : 0) : stepDetails['isBeneficiaryNotify'],
            isPetitionerNotify: stepDetails['isPetitionerNotify'],
            receiptCategory: '',
            receiptDate: '',
            receiptNumber: '',
            receiptType: '',
            responseCode: stepDetails.stepResponseDetails && stepDetails.stepResponseDetails['stepResponseCode'] ? stepDetails.stepResponseDetails['stepResponseCode'] : null,
            responseNote: stepDetails['stepResponseNote'] ? stepDetails['stepResponseNote'] : responseNote ? responseNote : '',
            reviewCode: stepDetails.stepReviewDetails && stepDetails.stepReviewDetails['stepReviewCode'] ? stepDetails.stepReviewDetails['stepReviewCode'] : null,
            reviewNote: stepDetails.stepReviewDetails && stepDetails.stepReviewDetails['stepReviewNote'] ? stepDetails.stepReviewDetails['stepReviewNote'] : null,
            startDate: '',
            statusCode: status,
            stepNote: stepDetails['stepNote'] ? stepDetails['stepNote'] : '',
            notesAvailable: stepDetails['notesAvailable']
        };
    }
    // Updating step status for visa
    updateStepStatus(visatype, taskId, stepId, payload) {
        let selectedState = sessionStorage.getItem('selectedState');
        if (selectedState == 'simple') {
            return this.httpClient.post(`/${visatype}/task/${taskId}/step/${stepId}/update?isSimplifiedProfile=true`, payload).pipe(map((response) => {
                if (response && response.status === 200) {
                    return response;
                }
            }));
        }
        else {
            return this.httpClient.post(`/${visatype}/task/${taskId}/step/${stepId}/update`, payload).pipe(map((response) => {
                if (response && response.status === 200) {
                    return response;
                }
            }));
        }
    }
    getTask(taskId) {
        return this.httpClient.get(`/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getVisaTask(taskId, visaTypeCode) {
        return this.appServicesLibraryService.getTask(visaTypeCode, taskId);
    }
    saveUpdateSubTask(payload, taskType, isGctask) {
        const reqUrl = isGctask ? `/task/immigrantCode/${taskType}}/immigrationCategory/${payload.immCategoryCode}/immigrationClasification/${payload.immClassificationCode}` : `/${taskType}/task/${payload.id}/update`;
        return this.httpClient.post(`${reqUrl}`, payload)
            .pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
StepStatusUpdatePayloadService.ɵfac = function StepStatusUpdatePayloadService_Factory(t) { return new (t || StepStatusUpdatePayloadService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppServicesLibraryService)); };
StepStatusUpdatePayloadService.ɵprov = i0.ɵɵdefineInjectable({ token: StepStatusUpdatePayloadService, factory: StepStatusUpdatePayloadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepStatusUpdatePayloadService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of step-status-update-payload-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StepStatusUpdatePayloadService };
//# sourceMappingURL=step-status-update-payload-service.js.map
